import {DataStatus, TabProps, Tabs} from 'platform/components';
import {VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {buildArray, useQueryState} from 'shared/web';

import {IntegrationBox} from './components/IntegrationBox';
import {OPERATORS} from './constants/operators';
import {useUserExternalSystems} from './hooks/useUserExternalSystems';

interface UserExternalSystemsProps {
  userId: string | undefined;
  isReadonly?: boolean;
}

export function UserExternalSystems(props: UserExternalSystemsProps) {
  const [activeTabId, setActiveTabId] = useQueryState('selected-operator');

  const {
    mercedesProfiles,
    mazdaProfiles,
    otherProfiles,
    isWithoutExternalSystems,
    isLoading: isLoadingIntegrations,
  } = useUserExternalSystems(props.userId);

  const tabs = buildArray<TabProps>()
    .when(mercedesProfiles.length > 0, {
      id: OPERATORS.MERCEDES,
      title: i18n.t('page.employeeDetail.externalSystems.mercedes'),
      content: (
        <VStack spacing={4}>
          {mercedesProfiles.map((profiles) => (
            <IntegrationBox
              key={profiles.integrationCode}
              integrationCode={profiles.integrationCode}
              integrations={profiles.integrations ?? []}
              isLoading={isLoadingIntegrations}
              userId={props.userId}
            />
          ))}
        </VStack>
      ),
    })
    .when(mazdaProfiles.length > 0, {
      id: OPERATORS.MAZDA,
      title: i18n.t('page.employeeDetail.externalSystems.mazda'),
      content: (
        <VStack spacing={4}>
          {mazdaProfiles.map((profiles) => (
            <IntegrationBox
              key={profiles.integrationCode}
              integrationCode={profiles.integrationCode}
              integrations={profiles.integrations ?? []}
              isLoading={isLoadingIntegrations}
              userId={props.userId}
              isReadonly={props.isReadonly}
            />
          ))}
        </VStack>
      ),
    })
    .when(otherProfiles.length > 0, {
      id: OPERATORS.OTHER,
      title: i18n.t('page.employeeDetail.externalSystems.other'),
      content: (
        <VStack spacing={4}>
          {otherProfiles.map((profiles) => (
            <IntegrationBox
              key={profiles.integrationCode}
              integrationCode={profiles.integrationCode}
              integrations={profiles.integrations ?? []}
              isLoading={isLoadingIntegrations}
              userId={props.userId}
            />
          ))}
        </VStack>
      ),
    });

  return (
    <VStack spacing={4}>
      <DataStatus
        isEmpty={isWithoutExternalSystems}
        isLoading={isLoadingIntegrations}
        spacing={20}
        emptySubheadline={i18n.t('page.employeeDetail.labels.noExternalSystems')}
      >
        <Tabs tabs={tabs} activeTabId={activeTabId} onChange={setActiveTabId} />
      </DataStatus>
    </VStack>
  );
}
